export default [
    {
        path: "/marketplace/product/list",
        name: "ecommerce product admin list",
        component: () => import("@/views/Ecommerce/Product/Admin/List"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Product List",
            breadcrumb: [
                {
                    text: 'Product List',
                    active: true,
                },
            ],
        },
    },
    {
        path: "/marketplace/product",
        name: "ecommerce product customer list",
        component: () => import("@/views/Ecommerce/Product/List"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Shop",
            breadcrumb: [
                {
                    text: 'Shop',
                    active: true,
                },
            ],
        },
    },
    {
        path: "/marketplace/product/create",
        name: "ecommerce product admin create",
        component: () => import("@/views/Ecommerce/Product/Admin/Upsert"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Product Add",
            breadcrumb: [
                {
                    text: 'Product Add',
                    active: true,
                },
            ],
        },
    },
    {
        path: "/marketplace/product/:id/update",
        name: "ecommerce product admin update",
        component: () => import("@/views/Ecommerce/Product/Admin/Upsert"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Product Update",
            breadcrumb: [
                {
                    text: 'Product Update',
                    active: true,
                },
            ],
        },
    },
    {
        path: "/marketplace/product/:id",
        name: "ecommerce product customer list",
        component: () => import("@/views/Ecommerce/Product/Show"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Product Details",
            breadcrumb: [
                {
                    text: 'Product Details',
                    active: true,
                },
            ],
        },
    },

    {
        path: "/marketplace/checkout",
        name: "ecommerce checkout",
        component: () => import("@/views/Ecommerce/Checkout/Checkout"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Checkout",
            breadcrumb: [
                {
                    text: 'Checkout',
                    active: true,
                },
            ],
        },
    },
    {
        path: "/marketplace/order",
        name: "ecommerce order list",
        component: () => import("@/views/Ecommerce/Order/List"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Orders",
            breadcrumb: [
                {
                    text: 'Orders',
                    active: true,
                },
            ],
        },
    },
    {
        path: "/marketplace/order/:id",
        name: "ecommerce order show",
        component: () => import("@/views/Ecommerce/Order/Show"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Order Details",
            breadcrumb: [
                {
                    text: 'Order Details',
                    active: true,
                },
            ],
        },
    },

    {
        path: "/marketplace/order/:id/update",
        name: "ecommerce order update",
        component: () => import("@/views/Ecommerce/Order/Edit"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Order Details",
            breadcrumb: [
                {
                    text: 'Order Details',
                    active: true,
                },
            ],
        },
    },
    {
        path: "/marketplace/product/:id/stock",
        name: "ecommerce product stock",
        component: () => import("@/views/Ecommerce/Product/Admin/Stock"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Product Stock",
            breadcrumb: [
                {
                    text: 'Product Stock',
                    active: true,
                },
            ],
        },
    },

    {
        path: "/marketplace/category",
        name: "ecommerce category admin list",
        component: () => import("@/views/Ecommerce/Category/List"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Product Categories",
            breadcrumb: [
                {
                    text: 'Product Categories',
                    active: true,
                },
            ],
        },
    },

    {
        path: "/marketplace/vendor",
        name: "ecommerce vendor list",
        component: () => import("@/views/Ecommerce/Vendor/List"),
        meta: {
            pageTitle: "Product Vendors",
            breadcrumb: [
                {
                    text: 'Product Vendors',
                    active: true,
                },
            ],
        },
    },

    //Classifieds
    {
        path: "/classified/category",
        name: "classified category admin list",
        component: () => import("@/views/Classified/Category"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Classified Categories",
            breadcrumb: [
                {
                    text: 'Classified Categories',
                    active: true,
                },
            ],
        },
    },

    {
        path: "/classified",
        name: "classified list",
        component: () => import("@/views/Classified/List"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Classifieds",
            breadcrumb: [
                {
                    text: 'Classifieds',
                    active: true,
                },
            ],
        },
    },
    {
        path: "/classified/create",
        name: "classified create",
        component: () => import("@/views/Classified/Upsert"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Classifieds",
            breadcrumb: [
                {
                    text: 'Classifieds',
                    active: true,
                },
            ],
        },
    },
    {
        path: "/classified/:id",
        name: "classified show",
        component: () => import("@/views/Classified/Show"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Classifieds",
            breadcrumb: [
                {
                    text: 'Classifieds',
                    active: true,
                },
            ],
        },
    },
    {
        path: "/classified/:id/update",
        name: "classified show",
        component: () => import("@/views/Classified/Upsert"),
        meta: {
            resource: 'marketplace',
            pageTitle: "Classifieds",
            breadcrumb: [
                {
                    text: 'Classifieds',
                    active: true,
                },
            ],
        },
    },
];
